import React from "react";
import { Component } from "react";
import { Button } from "react-bootstrap";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Errors } from "react-redux-form";

import { ControlSelect, ControlText, ControlTextarea } from "../../../../common/custom-form/control-field.component";
import { CustomDropdown } from "../../../../common/custom-form/custom-dropdown.component";
import { inventoryCircuitSimActions } from "../../../../../store/external/inventory/details-view/add-sim.reducer";
import { ACTION_TYPES, Selected_Index } from "../../../../../constants/external-constants";
import Translation from "../../../../../components/common/translation/translation.component";

import TableWithButton from "../../../../common/details-table/table-with-button.component";
import { ConfirmationNotificationModal } from "../../../../common/modal/confirmation-modal.component";
import { NotificationModal } from "../../../../common/modal/notification-modal.component";
import { CONFIRMATION_VALUE } from "../../../../../utils/constant.utils";
import { assignDefaultIfEmptyString, hasObjectWithProperty } from '../../../../../utils/helpers.utils';

class AddSim extends Component {
    constructor(props) {
        super(props);
        this.state = {
            updateSimDetails: false,
            activeDropdown: false,
            showDetails: false,
            showModal: false,
            showNotif: false,
            notifTitle: null,
            tableLength: 0
        }
    }

    componentDidMount() {
        const { circuitId, getCircuitSimList } = this.props;    
        getCircuitSimList(circuitId).then(() =>{
            const { circuitSimList } = this.props.inventoryCircuitSIM;
            const tableLength = circuitSimList?.datatable[0]?.dataItem?.length;
                this.setState({tableLength})
            }); 
    }

    componentWillUnmount() {
        const { resetCircuitSimForm, resetCircuitSimDetails } = this.props;
        resetCircuitSimForm();
        resetCircuitSimDetails();
    }

    showDetails(value) {
        this.setState({
            showDetails: value
        });
    }

    onClickCancel = () => {
        const { resetCircuitSimForm, toggleDropdown } = this.props;
        this.toggleActiveState();
        resetCircuitSimForm();

        this.setState({
            updateSimDetails: false
        });
    }
    onClickAdd = () =>{

        this.setState({
            showModal: true,
            notifTitle: 'added'
        })
    }
    handleConfirmationModal = (buttonType) =>{
        if (buttonType === CONFIRMATION_VALUE.Ok){
            this.state.updateSimDetails ? this.updateCircuitSIM() : this.addCircuitSIM()
            this.props.handleChangesStatus('simChange', true);
            this.setState( prev => ({
                showModal: !prev.showModal,
                showNotif: false
            }))
        }else{
            this.setState({
                showModal: false
            });
        }
    }

    toggleActiveState = () => {
        this.setState(prevState => ({ activeDropdown: !prevState.activeDropdown }));
    }

    onRowClick = (index) => {
        const { toggleDropdown, viewCircuitSimItem } = this.props;
        viewCircuitSimItem(index);

        this.setState({
            activeDropdown: true,
            updateSimDetails: true
        });
    }

    updateCircuitSIM = () => {
        const { updateCircuitSimItem, resetCircuitSimForm, toggleDropdown } = this.props;

        updateCircuitSimItem();
        toggleDropdown(Selected_Index.i_Five);
        resetCircuitSimForm();

        this.setState({
            updateSimDetails: false,
            notifTitle: 'updated',
            activeDropdown: false
        });
    }

    addCircuitSIM = () => {
        const { addCircuitSimItem, resetCircuitSimForm, toggleDropdown } = this.props;

        addCircuitSimItem();
        toggleDropdown(Selected_Index.i_Five);
        resetCircuitSimForm();
        this.toggleActiveState(false);
    }
    deleteCircuitSimItem = (index) =>{
        const {deleteCircuitSimItem, handleChangesStatus} = this.props;

        const {circuitSimList} = this.props.inventoryCircuitSIM;

        deleteCircuitSimItem(index);    

        const updatedSimList = circuitSimList;

        let newTable = updatedSimList?.datatable[0]?.dataItem;

        newTable.splice(index, 1); 

        handleChangesStatus('simChange', true);
        

        const containsObjectWithID = hasObjectWithProperty(newTable, "ID", -1);

            if(containsObjectWithID || this.state.tableLength !== newTable.length){
                handleChangesStatus('simChange', true);
            }else{
                handleChangesStatus('simChange', false);
            }
    }
    handleCloseNotif = () =>{
        this.setState({showNotif:false});
    }
    handleOpenNotif = () =>{
        this.setState({
            showNotif: true,
            notifTitle: 'deleted'
        });
    }

    render() {
        const { inventoryCircuitSIMForm, translator, hasPendingApproval } = this.props;
        const { circuitSimList, simTypes, simRanks } = this.props.inventoryCircuitSIM;
        const enableAddBtn = inventoryCircuitSIMForm.TypeID && inventoryCircuitSIMForm.Rank && inventoryCircuitSIMForm.SerialNumber;
        const enableUpdateBtn = this.state.updateSimDetails ? (inventoryCircuitSIMForm.TypeID && inventoryCircuitSIMForm.Rank && inventoryCircuitSIMForm.SerialNumber) &&
            (circuitSimList.datatable[0].dataItem[inventoryCircuitSIMForm.ID].AdditionalInformation != assignDefaultIfEmptyString(inventoryCircuitSIMForm.AdditionalInformation, null) ||
                circuitSimList.datatable[0].dataItem[inventoryCircuitSIMForm.ID].PINNumber != assignDefaultIfEmptyString(inventoryCircuitSIMForm.PINNumber, null) ||
                circuitSimList.datatable[0].dataItem[inventoryCircuitSIMForm.ID].PUK1 != assignDefaultIfEmptyString(inventoryCircuitSIMForm.PUK1, null) ||
                circuitSimList.datatable[0].dataItem[inventoryCircuitSIMForm.ID].PUK2 != assignDefaultIfEmptyString(inventoryCircuitSIMForm.PUK2, null) ||
                circuitSimList.datatable[0].dataItem[inventoryCircuitSIMForm.ID].ProductName != assignDefaultIfEmptyString(inventoryCircuitSIMForm.ProductName, null) ||
                circuitSimList.datatable[0].dataItem[inventoryCircuitSIMForm.ID].Rank != inventoryCircuitSIMForm.Rank ||
                circuitSimList.datatable[0].dataItem[inventoryCircuitSIMForm.ID].SIM != assignDefaultIfEmptyString(inventoryCircuitSIMForm.SIM, null) ||
                circuitSimList.datatable[0].dataItem[inventoryCircuitSIMForm.ID].SerialNumber != inventoryCircuitSIMForm.SerialNumber ||
                circuitSimList.datatable[0].dataItem[inventoryCircuitSIMForm.ID].Type != inventoryCircuitSIMForm.Type ||
                circuitSimList.datatable[0].dataItem[inventoryCircuitSIMForm.ID].TypeID != inventoryCircuitSIMForm.TypeID
                ? true : false) : false;

        return (
            <>
                 <NotificationModal 
                    show={this.state.showNotif} 
                    title={'Success'} 
                    message={`Sim circuit ${this.state.notifTitle} successfully!`}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal notification-footer'}
                />
                <Errors model="inventoryCircuitForm.circuitSIMs" className="has-error" />
                <div className="control-container">
                    <CustomDropdown activeDropdown={this.state.activeDropdown} toggleActiveState={this.toggleActiveState} label={<Translation translationKey="add_sim" />} >
                        <div className={`add-sim-container detail-page-container details-4-col-container`}>
                            <ControlSelect label={<Translation translationKey="sim_type" />} options={simTypes} model="inventoryCircuitSIMForm.TypeID" isRequired={true} value={inventoryCircuitSIMForm.TypeID} placeholder={`${translator('select_placeholder')}`}/>
                            <ControlSelect label={<Translation translationKey="sim_rank" />} options={simRanks} model="inventoryCircuitSIMForm.Rank" isRequired={true} value={inventoryCircuitSIMForm.Rank} placeholder={`${translator('select_placeholder')}`}/>
                            <ControlText customClass={"custom-alignment-left"} label={<Translation translationKey="serial_number" />} model="inventoryCircuitSIMForm.SerialNumber" isRequired={true} value={inventoryCircuitSIMForm.SerialNumber} placeholder={`${translator('enter_text_placeholder')}`} maxLength={100} />
                            <ControlText label={<Translation translationKey="pin_number" />} model="inventoryCircuitSIMForm.PINNumber" value={inventoryCircuitSIMForm.PINNumber} placeholder={`${translator('enter_text_placeholder')}`} maxLength={100} />
                            <ControlText customClass={"custom-alignment-left"} label={<Translation translationKey="product_name" />} model="inventoryCircuitSIMForm.ProductName" value={inventoryCircuitSIMForm.ProductName} placeholder={`${translator('enter_text_placeholder')}`} maxLength={100} />
                            <ControlText label={<Translation translationKey="sim" />} model="inventoryCircuitSIMForm.SIM" value={inventoryCircuitSIMForm.SIM} placeholder={`${translator('enter_text_placeholder')}`} maxLength={100} />
                            <ControlText label={<Translation translationKey="puk_one" />} model="inventoryCircuitSIMForm.PUK1" value={inventoryCircuitSIMForm.PUK1} placeholder={`${translator('enter_text_placeholder')}`} maxLength={100} />
                            <ControlText label={<Translation translationKey="puk_two" />} model="inventoryCircuitSIMForm.PUK2" value={inventoryCircuitSIMForm.PUK2} placeholder={`${translator('enter_text_placeholder')}`} maxLength={100} />
                            <ControlTextarea label={<Translation translationKey="additional_information" />} model="inventoryCircuitSIMForm.AdditionalInformation" colClassName="details-container-full-row" value={inventoryCircuitSIMForm.AdditionalInformation} placeholder={`${translator('enter_text_placeholder')}`} maxLength={255} />

                            <div className="add-button-container custom-add-button">
                                <div className="btn-tooltiptext">
                                    <Button onClick={this.onClickCancel} className="btn-custom-violet-hover-outline">Cancel</Button>
                                    <span className="tooltip-text">{<Translation translationKey="cancel_add_sim_details" />}</span>
                                </div>
                                <ConfirmationNotificationModal
                                    show={this.state.showModal}
                                    message={this.state.updateSimDetails ? 'Are you sure you want to update?' : 'Are you sure you want to add?'}
                                    title={this.state.updateSimDetails ? 'Update' : 'Add'}
                                    handleModal={this.handleConfirmationModal}
                                    className={'comment-notification-modal'}
                                    customClass={'comment-notification-modal modal-text-bold'}
                                />
                                <div className={'btn-tooltiptext'}>
                                    <Button
                                        className="btn-add"
                                        disabled={(this.props.isReadOnly || this.props.isReadAndExtractOnly) ? true : hasPendingApproval ? hasPendingApproval :
                                            (this.state.updateSimDetails ? !enableUpdateBtn : !enableAddBtn)} 
                                        onClick={this.onClickAdd}>{`${this.state.updateSimDetails ? ACTION_TYPES.Update : ACTION_TYPES.Add}`}
                                    </Button>
                                    <span className="tooltip-text">{`${this.state.updateSimDetails ? 'Update sim details' : 'Add SIM details'}`}</span>
                                </div>
                            </div>
                        </div>
                    </CustomDropdown>
                </div>
                {circuitSimList.datatable.length > 0 && circuitSimList.datatable[0].dataItem.length > 0 &&
                    <div className="details-table-container add-sim-container">                        
                             <TableWithButton
                                classNameWrapper="table-details-wrapper table-clickable"
                                datatable={circuitSimList.datatable}
                                haveExternalDeleteBtn={this.props.IsReadOnly ? false : (this.props.isReadAndExtractOnly ? false : (this.props.isReadAndWrite ? true : false))}
                                deleteAction={(index) => this.deleteCircuitSimItem(index)}
                                rowClickAction={this.onRowClick}
                                updateNotifTitle={this.updateNotifTitle}
                                handleOpenNotif={this.handleOpenNotif}
                             />  
                    </div>

                }
            </>
        )
    }
}

export default connect(
    state => {
        const { inventoryCircuitSIM } = state;
        const { inventoryCircuitSIMForm } = state.form;
        return {
            inventoryCircuitSIM
            , inventoryCircuitSIMForm
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, inventoryCircuitSimActions),
        dispatch
    )
)(AddSim);